import React from 'react'
import { Menu } from 'antd';
import { NavLink } from 'react-router-dom';

const SubMenu = Menu.SubMenu;


const MobileNavigation = (props) => {
    return (
        <Menu
            className="sub1Menu sub2Menu"
            // style={{ width: "100%" ,background: "#036"}}
            // defaultSelectedKeys={['1']}
            // defaultOpenKeys={['sub1']}
            mode="inline"
        >
            <SubMenu title="Menu" key="sub1" style={{ background: "#003f87" }}>
                {props.nave.map((data, i) => {
                 return <Menu.Item key="/alumni-dashboard"> <NavLink to={data.link}> {data.name}</NavLink> </Menu.Item>
                })}
            </SubMenu>
        </Menu>

    )
}

export default MobileNavigation;


// WEBPACK FOOTER //
// ./src/components/Inc/MobileNavigation.js